import { Controller, useFormContext } from "react-hook-form";

import { NcComboBox, NcComboBoxProps } from "./nc-combo-box";

export interface NcFormComboBoxProps
  extends Omit<NcComboBoxProps, "name" | "validate" | "onBlur" | "value" | "validationBehavior"> {
  name: string; // Was optional in NcComboBox and is now required
}

export const NcFormComboBox = ({ name, onChange: onChangeProp, ...props }: NcFormComboBoxProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcComboBox
          name={name}
          value={value ? value : ""}
          onChange={key => {
            onChangeProp?.(key);
            const selectedValue = key || undefined;
            onChange(selectedValue);
          }}
          onBlur={onBlur}
          validationBehavior="aria"
          isInvalid={invalid}
          error={error}
          ref={ref}
          {...props}
        />
      )}
    />
  );
};
